// src/hooks/usePageMeta.js
import { useEffect } from "react";

export function usePageMeta({ title, description }) {
  useEffect(() => {
    // Ganti title tab
    if (title) {
      document.title = title;
    }

    // Update meta description utama
    if (description) {
      const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", description);
      }
    }
  }, [title, description]); // akan jalan kalau title/description berubah
}
